//--------------- IMPORTAÇÕES ---------------//
import { X, Trash2, Plus } from "lucide-react";
import { useEffect, useContext } from "react";
import { LeadsContext } from "../../context/LeadsContext";
import { associateTagService, createTagService, disassociateTagService, loadTagsService } from "../../services";



//--------------- EXPORTAÇÃO DO MODAL TAGS LEAD ---------------//
export default function ModalTagsLead() {



  //--------------- CRIAÇÃO DE HOOKS ---------------//
  const { isOpenModalTags, setIsOpenModalTags } = useContext(LeadsContext);
  const { leads, setLeads } = useContext(LeadsContext);
  const { leadModalTags, setLeadModalTags } = useContext(LeadsContext);
  const { tagsModalTags, setTagsModalTags } = useContext(LeadsContext);
  const { newTag, setNewTag } = useContext(LeadsContext);
  const { suggestions, setSuggestions } = useContext(LeadsContext);



  //--------------- USE EFFECT DE INICIALIZAÇÃO ---------------//
  useEffect(() => {
    handleSearchTags(newTag);
  }, [newTag]);



  //--------------- FUNÇÃO HANDLE UPDATE TAGS COUNT ---------------//
  function handleUpdateTagsCount(id, total) {
    setLeads(prev =>
      prev.map(l => l.id === id ? { ...l, total_tags: total } : l)
    );
  }



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE SEARCH TAGS ---------------//
  async function handleSearchTags(q) {
    if (!q) return setSuggestions([]);
    const response = await loadTagsService(q);
    if (response) {
      setSuggestions(response.data);
    }
  };



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE ASSOCIATE TAG  ---------------//
  async function handleAssociateTag(tag_id, nome = null) {
    let tag;

    if (nome && !tag_id) {
      const response = await createTagService(nome);
      if (response) {
        tag = response.data;
        tag_id = tag.id;
      } else {
        return;
      }
    } else {
      tag = suggestions.find(t => t.id === tag_id);
    }

    const response = await associateTagService(leadModalTags.id, tag_id);
    if (!response) {
      return;
    }

    if (!tagsModalTags.find(t => t.id === tag_id)) {
      const novas = [...tagsModalTags, tag];
      setTagsModalTags(novas);
      if (handleUpdateTagsCount) {
        handleUpdateTagsCount(leadModalTags.id, novas.length);
      }
    }
    setNewTag("");
    setSuggestions([]);
  };



  //--------------- FUNÇÃO ASSÍNCRONA HANDLE REMOVE TAG  ---------------//
  async function handleRemoveTag(tagId) {
    const response = await disassociateTagService(leadModalTags.id, tagId)
    if (response) {
      const novas = tagsModalTags.filter(tag => tag.id !== tagId);
      setTagsModalTags(novas);
      if (handleUpdateTagsCount) {
        handleUpdateTagsCount(leadModalTags.id, novas.length);
      }
    }

  };



  //--------------- RETORNO CONDICIONAL DO MODAL TAGS LEAD ---------------//
  return (
    <>
      {!leadModalTags || !isOpenModalTags
        ? null
        :
        <>
          <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">

            <div className="bg-surface-1 border border-white/[0.08] rounded-xl p-6 w-full max-w-md">
              <div className="flex justify-between items-center mb-4">
                <h2 className="text-xl font-bold">Tags de {leadModalTags.nome}</h2>
                <button onClick={() => setIsOpenModalTags(false)}>
                  <X className="w-5 h-5 text-white hover:text-red-400" />
                </button>
              </div>

              <div className="w-full h-full max-h-[50vh] scrollbar scrollbar-thumb-zinc-700 scrollbar-track-zinc-900 overflow-y-scroll mb-[2vh]">
                {tagsModalTags.length > 0 ? (
                  <div className="flex flex-wrap gap-2 mb-4">
                    {tagsModalTags.map(tag => (
                      <div key={tag.id} className="bg-brand-600 text-white px-3 py-1 rounded-full flex items-center gap-2">
                        <span className="text-sm">{tag.nome}</span>
                        <button onClick={() => handleRemoveTag(tag.id)}>
                          <Trash2 className="w-3 h-3 text-white hover:text-red-300" />
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-ink-3 mb-4">Nenhuma tag vinculada a este lead.</p>
                )}
              </div>

              <div className="mb-4 relative">
                <div className="mb-4 flex gap-2">
                  <input
                    type="text"
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                    placeholder="Buscar ou criar tag..."
                    className="bg-surface-2 px-3 py-2 rounded border border-white/[0.08] w-full"
                  />
                  <button
                    disabled={!newTag.trim()}
                    onClick={() => handleAssociateTag(null, newTag.trim())}
                    className="bg-brand-600 hover:bg-brand-700 px-3 py-2 rounded text-white disabled:opacity-40"
                    title="Criar nova tag"
                  >
                    <Plus className="w-4 h-4" />
                  </button>
                </div>
                {newTag.trim() !== "" && (
                  <ul className="absolute z-50 w-full bg-surface-2 border border-white/[0.08] mt-1 rounded max-h-40 overflow-y-auto">
                    {suggestions.map(tag => (
                      <li
                        key={tag.id}
                        onClick={() => handleAssociateTag(tag.id)}
                        className="px-3 py-2 hover:bg-surface-3 cursor-pointer text-sm"
                      >
                        {tag.nome}
                      </li>
                    ))}
                    {suggestions.length === 0 && (
                      <li
                        onClick={() => handleAssociateTag(null, newTag.trim())}
                        className="px-3 py-2 hover:bg-surface-3 cursor-pointer text-sm text-green-400"
                      >
                        Criar nova tag "{newTag.trim()}"
                      </li>
                    )}
                  </ul>
                )}
              </div>

              <div className="text-right">
                <button onClick={() => setIsOpenModalTags(false)} className="px-4 py-2 bg-surface-3 hover:bg-surface-4 rounded">
                  Fechar
                </button>
              </div>
            </div>

          </div>
        </>
      }
    </>
  )
}